import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"


export default {
  __name: 'index',
  setup(__props) {

// import { reactive,getCurrentInstance,onMounted } from "vue";
// const data = reactive({
//   transtionName:"fade"
// })

return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component,route }) => [
      _createVNode(_Transition, {
        name: route.meta.transition
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: route.fullPath
          }))
        ]),
        _: 2
      }, 1032, ["name"])
    ]),
    _: 1
  }))
}
}

}